import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ApiFormToolbar = ({ configName }) => {
  const { t } = useTranslation("common");

  return (
    <div className="view-toolbar">
      <Link to="/api-generator/view" className="btn-back">
        ← {t("Go Back")}
      </Link>
      {configName ? (
        <span className="api-form-toolbar-hint">
          {t("Live record data from")} {configName}
        </span>
      ) : null}
    </div>
  );
};

ApiFormToolbar.propTypes = {
  configName: PropTypes.string
};

ApiFormToolbar.defaultProps = {
  configName: ""
};

export default ApiFormToolbar;
